/**
 * formata valor monetario (centavos -> R$ X.XXX,XX).
 * unica fonte de truth pra renderizacao monetaria no web.
 */

const formatador = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatarCentavos = (centavos: number): string => formatador.format(centavos / 100);

export const MoneyDisplay = ({
  centavos,
  className,
}: {
  centavos: number;
  className?: string;
}) => <span className={className}>{formatarCentavos(centavos)}</span>;
